import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';
import { submitContractEndpoint } from '../../../common/endpoints';

export const submitContract = createApi(submitContractEndpoint, 'POST');

const SubmitContract = createSlice({
  name: 'SubmitContract',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(submitContract.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(submitContract.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(submitContract.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default SubmitContract.reducer;